export class UploadDhsRequestFileRequest {
  classification: string = "";
  disseminationControlIds: string[] = [];
  dhsRequestId: string = "";
  uploadRequestId: string = "";
  file!: File;
  scis: string[] = [];
}
